export default __webpack_public_path__ + "static/parallax-1-b49458a7c8bc74aad5f513d886878206.png";